import { ITheme } from '@williamhill/rosi-ui-shared/src/themes';
import WILLIAM_HILL from '@williamhill/rosi-ui-shared/src/themes/william-hill';

const GENERIC: ITheme = {
  ...WILLIAM_HILL
};

export default GENERIC;
